import PageStyle from "@/styles/pages/clients/job-sharing/_index.module.scss";
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Button from '@/components/button';
import {getClientUsers} from '@/actions/pages/clients/jobs/interview_stages';
import { TRANSLATION } from "@/constants/common/internationalisation";

export class OfferActions
{

  constructor(setApprovalOptions, approvalDropdownRef, t) {
    this.setApprovalOptions = setApprovalOptions;
    this.approvalDropdownRef = approvalDropdownRef;
    this.t =  t
  }

  shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }
  renderInputComponent = inputProps => (
    <div className="buttonIn AutoSuggestInput__Tags">
        <div className={PageStyle.Tagrow}>
          {inputProps.selectedValues?.map((item, index) => (
            <div className={PageStyle.Tagrow__Tags} key={`job_approvers_${inputProps.index}`}>
              {item.name ? <span>{item.name}</span> : <span>{item.email}</span>}
              <button
                type="button"
                className={PageStyle.Tagrow__Cancel}
                onClick={() => inputProps.offerActions.handleEmailDelete(inputProps.formik, index)}
              >
                {inputProps.closeIcon}
              </button>
            </div>
          ))}
        </div>
        <input className = {PageStyle.Form__Input} autoComplete={"password"}
      {...inputProps} />
      <Button buttonstyle={`${PageStyle.nobgbutton} addbtn`} disabled={inputProps.disabled} onClick={() => this.onAddClick(event, inputProps)}>{TRANSLATION('button:add:default')}</Button>
    </div>
  );

  getUserSuggestionValue(suggestion) 
  {
    return `${suggestion.user_attributes.email}`;
  }

  showSuggestion(suggestion){
    
    
  }
  
  renderUserSuggestion(suggestion) {
    let response = '';
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      response = `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      response = `${suggestion.user_attributes.name}`
    }
    else{
      response = `${suggestion.user_attributes.email}`
    }
    return (
      <span>{response}</span>
    );
  }

   escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async getUserSuggestions(value, router) {
    const escapedValue = this.escapeRegexCharacters(value?.trim());
    
    if (escapedValue === '') {
    return [];
    }
    let finalUsers = await getClientUsers(escapedValue, '3', router)
    return finalUsers
  }
  
  async  onUserSuggestionsFetchRequested(hash, setUsers){  
    let users = await this.getUserSuggestions(hash.value)
    setUsers(users)
  };
  
  onUserSuggestionsClearRequested = (setUsers) => {
    setUsers([])
  };
  
  isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
  }

  onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial){
    if(this.isEmail(email) && !old_emails.includes(email))
    {
      old_emails.unshift(email)
      old_initials.unshift(new_initial) 
      this.setOptions(old_emails.length)
      formik.setFieldValue('offer.offer_approvals_attributes.0.minimum_approval_required', '')
      this.approvalDropdownRef.current?.select?.clearValue();
    }
    
  }

  handleKeyDown(evt, formik, setApproverEmail, setApproverEmailError, t){
    if (["Enter"].includes(evt.key)) {
      evt.preventDefault();
      let email = evt.target.value
      if(this.isEmail(email))
      {
        { this.onUserSuggestionSelection(formik, formik.values.offer.offer_approvals_attributes[0].approver_emails, email, formik.values.offer.offer_approvals_attributes[0].approver_initials, {email: email, name_initials: null, name: null})
        setApproverEmail('')
        }
      }
      else
      {                      
        setApproverEmailError(t("errors:autocomplete_invalid_email"));
      }
    };
  }

  onAddClick = (event, params) => {
    let email = params.value 
    if(this.isEmail(email))
    {
      { this.onUserSuggestionSelection(params.formik, params.formik.values.offer.offer_approvals_attributes[0].approver_emails, email, params.formik.values.offer.offer_approvals_attributes[0].approver_initials, {email: email, name_initials: null, name: null})
      params.setApproverEmail('')
      }
    }
    else
    {                      
      params.setApproverEmailError(params.t("errors:autocomplete_invalid_email"));
    }
  }

  handleEmailDelete(formik, itemIndex )
  {
    let emails = formik.values.offer.offer_approvals_attributes[0].approver_emails
    let name_initials = formik.values.offer.offer_approvals_attributes[0].approver_initials
    emails.splice(itemIndex, 1)
    name_initials.splice(itemIndex, 1)
    this.setOptions(emails.length)
    formik.setFieldValue('offer.offer_approvals_attributes.0.minimum_approval_required', '')
    this.approvalDropdownRef.current?.select?.clearValue();
  }

  setOptions(len){
    let options = [{value: len, label:this.t('career:jobs:all')}]
    for(let i=1; i < len; i++){
      options.push({value: i, label: this.t('career:jobs:any', {i})})
    }
    return len == 0 ? this.setApprovalOptions([]) : this.setApprovalOptions(options);
  }
}